import React from 'react';

import Levels from 'scenes/MarketingPlanning/MarketingPlanningWizard/components/Levels';

import AffiliateLevel from './AffiliateLevel';
import ApplicationLevel from './ApplicationLevel';
import ChannelLevel from './ChannelLevel';
import CountryLevel from './CountryLevel';
import ManagerLevel from './ManagerLevel';
import NetworkLevel from './NetworkLevel';
import PlatformLevel from './PlatformLevel';
import TotalLevel from './TotalLevel';

export default () => (
  <Levels
    totalLevel={<TotalLevel />}
    networkLevel={<NetworkLevel />}
    applicationLevel={<ApplicationLevel />}
    channelLevel={<ChannelLevel />}
    platformLevel={<PlatformLevel />}
    affiliateLevel={<AffiliateLevel />}
    countryLevel={<CountryLevel />}
    managerLevel={<ManagerLevel />}
    withBudgetSum={false}
  />
);
